<template>
  <div>
    <h4>Categories</h4>
    <el-menu
        ref="el-menu"
        default-active="1"
        :text-color="'#333'"
        :active-text-color="'#000'"
        :background-color="'transparent'"
        @select="handleSelect">
      <el-menu-item
          v-for="(category, index) in categories"
          :index="String(index + 1)"
          :key="category.value"
          :data-value="category.value">
        <span>{{ category.label }}</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
import { tag } from '@meta/widget/templates'

export default {
  name: 'CategoriesFilter',
  data() {
    return {
      categories: [
        { label: 'All', value: 'all' },
        { label: 'Grow Email List', value: tag.LEAD_GENERATION },
        { label: 'Feedback & Survey', value: tag.FEEDBACK },
        { label: 'Announcement', value: tag.ANNOUNCEMENT },
        { label: 'Know Your Customer', value: tag.CUSTOMER_SEGMENTATION },
        { label: 'Coupons & Offers', value: tag.COUPONS_OFFERS },
        // { label: 'Social Proof', value: 'social-proof' },
        // { label: 'Product Sales', value: 'product-sales' },
      ],
      activeCategoryIndex: 1, // Default 'All' active index
    }
  },
  methods: {
    handleSelect(index) {
      this.activeCategoryIndex = parseInt(index)
      this.$emit('category-select', this.categories[this.activeCategoryIndex - 1])
    },
  },
}
</script>